import { AsyncPipe, NgClass } from '@angular/common';
import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { DataKanban } from '@iupics-components/models/kanban-interface';
import { TextLimitPipe } from '@iupics-util/pipes/text-limit/text-limit.pipe';
import { listenWindowOutsideAngular } from '@iupics-util/tools/zone-listener.util';
import { TooltipModule } from 'primeng/tooltip';
import { DocServerUrlPipe } from '../../../../../iupics-util/pipes/doc-server-url/doc-server-url.pipe';

@Component({
  selector: 'iu-kanban-card-ui',
  templateUrl: './kanban-card-ui.component.html',
  styleUrls: ['./kanban-card-ui.component.scss'],
  standalone: true,
  imports: [NgClass, TooltipModule, AsyncPipe, TextLimitPipe, DocServerUrlPipe],
})
export default class KanbanCardUiComponent implements OnInit, OnChanges {
  @Input()
  datasKanban: DataKanban;
  @Input()
  tableName: string;
  isMobile = false;
  initials = '';
  constructor() {
    // one resize listener per card: outside Angular, enters only when the mobile breakpoint is crossed
    listenWindowOutsideAngular(
      'resize',
      () => this.#isMobileWidth() !== this.isMobile,
      () => (this.isMobile = this.#isMobileWidth())
    );
  }

  ngOnInit() {
    this.isMobile = this.#isMobileWidth();
  }

  ngOnChanges() {
    this.initials = this.#computeInitials();
  }

  #isMobileWidth(): boolean {
    return document.documentElement.clientWidth <= 480;
  }

  #computeInitials(): string {
    const firstText = this.datasKanban?.rows
      ?.flatMap((row) => [...(row.dataAlignLeft ?? []), ...(row.dataAlignright ?? [])])
      .find((value) => value.type === 'text' && value.value !== null && value.value !== undefined && `${value.value}`.trim());
    const words = `${firstText?.value ?? ''}`
      .split(/[^\p{L}\p{N}]+/u)
      .filter((word) => word.length > 0);
    if (words.length === 0) {
      return '?';
    }
    const initials = words.length > 1 ? words[0].charAt(0) + words[1].charAt(0) : words[0].substring(0, 2);
    return initials.toUpperCase();
  }
}
